import React, { useEffect, useState } from "react";
import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import api from "@/lib/api";

const fmt = (v) => v.toLocaleString("tr-TR", { minimumFractionDigits: v >= 1000 ? 2 : 4, maximumFractionDigits: v >= 1000 ? 2 : 4 });

function Rate({ it }) {
  const up = it.change > 0;
  const down = it.change < 0;
  const Icon = up ? ArrowUpRight : down ? ArrowDownRight : Minus;
  const color = up ? "text-[#00A650]" : down ? "text-[#FF3B30]" : "text-neutral-400";
  return (
    <div className="flex items-center gap-2 px-3 border-l border-neutral-300 first:border-l-0" data-testid={`market-rate-${it.code}`}>
      <div className="flex flex-col leading-tight">
        <span className="text-[10px] font-mono uppercase tracking-widest font-bold">{it.label}</span>
        <span className={`text-[10px] font-mono inline-flex items-center ${color}`} data-testid={`market-rate-${it.code}-change`}>
          <Icon size={11} />{Math.abs(it.change).toFixed(2)}%
        </span>
      </div>
      <div className="flex flex-col leading-tight text-[11px] font-mono text-right">
        <span><span className="text-neutral-400 mr-1">A</span><span data-testid={`market-rate-${it.code}-buying`}>{fmt(it.buying)}</span></span>
        <span><span className="text-neutral-400 mr-1">S</span><span data-testid={`market-rate-${it.code}-selling`}>{fmt(it.selling)}</span></span>
      </div>
    </div>
  );
}

export const MarketRatesStrip = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const load = () => api.get(`/market/rates?_ts=${Date.now()}`)
      .then(({ data: d }) => { setData(d); setError(false); })
      .catch(() => setError(true));
    load();
    const id = setInterval(() => { if (!document.hidden) load(); }, 60_000);
    return () => clearInterval(id);
  }, []);

  if (!data) {
    return error ? (
      <span className="text-[10px] font-mono uppercase text-neutral-400 border border-neutral-300 px-2 h-10 inline-flex items-center" data-testid="market-rates-error">
        Kur bilgisi alınamadı
      </span>
    ) : null;
  }
  const time = (data.updated_at || "").slice(11, 16);
  return (
    <div className="inline-flex items-center border border-neutral-300 bg-white h-10" data-testid="market-rates-strip"
      title={`Kaynak: ${data.source}${data.updated_at ? ` · Son güncelleme: ${data.updated_at}` : ""}${data.stale ? " · (önbellek)" : ""}`}>
      {data.items.map((it) => <Rate key={it.code} it={it} />)}
      {time && (
        <span className="px-2 text-[9px] font-mono text-neutral-400 border-l border-neutral-300 h-full inline-flex items-center" data-testid="market-rates-updated">
          {time}{data.stale ? "*" : ""}
        </span>
      )}
    </div>
  );
};
